<template>
  <textarea :placeholder="translate('lblTextArea')" @keyup="select" v-model="text"></textarea>
</template>

<script>
export default {
  data: () => ({
    text: '',
  }),
  props: {
    options: Array,
  },
  methods: {
    select() {
      const options = [];
      if (this.text.trim()) {
        options.push({
          value: this.text,
          selected: true,
        });
      }
      this.$emit('change', options);
    },
  },
  watch: {
    options() {
      // does not fire for the first free text question (or last, if going back)
      this.text = this.options && this.options.length > 0 ? this.options[0].value : '';
    },
  },
  created() {
    this.text = this.options && this.options.length > 0 ? this.options[0].value : '';
  },
};
</script>

<style lang="scss">
.kws-quiz {
  textarea {
    resize: vertical;
    height: rem(80px);
    min-height: rem(42px);
    max-height: 90vh;
    display: block;
    margin-bottom: rem(30px);
    width: 100%;
    border: 1px solid transparent;

    &:focus, &:hover {
      border: 1px solid $color-kws-light-gray-100;
    }
  }
}
</style>
